import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const tareasApi = createApi({
  reducerPath: "tareasApi",
  baseQuery: baseQuery(`${API_SERVER}/tareas`),
  tagTypes: [
    "Tareas",
    "Tarea",
    "Comisiones",
    "archivosTarea",
    "NotificacionesTareas",
    "PortafoliosTarea",
  ],
  endpoints: (builder) => ({
    getTarea: builder.query({
      query: (id) => `/${id}`,
      providesTags: ["Tarea"],
    }),
    agregarTareaInterna: builder.mutation({
      query: (body) => {
        return {
          url: `/interna`,
          method: "POST",
          body,
        };
      },
    }),
    tareasPendientesMasAntiguas: builder.query({
      query: () => "/tareasPendientesMasAntiguas",
    }),
    getTareasTotalesPorSucursalTipoTareaYFecha: builder.query({
      query: ({
        sucursal,
        tipoTarea,
        fecha,
        fechaInicio,
        fechaFin,
        estadoTarea,
        nombreTarea,
      }) => {
        const params = { tipoTarea, estadoTarea, nombreTarea, fecha };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/tareasTotalesPorSucursalTipoTareaYFecha/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getCantidadTareasAgrupadasPorNombreTarea: builder.query({
      query: ({ sucursal, nombre, fecha, tipo, fechaInicio, fechaFin }) => {
        const params = { tipo, fecha, nombre };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/cantidadTareasAgrupadasPorNombreTarea/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getTareasEmpleadosPorNombreTarea: builder.query({
      query: ({ sucursal, nombre, fecha, fechaInicio, fechaFin }) => {
        const params = { fecha, nombre };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/tareasEmpleadosPorNombreTarea/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getCantidadTareasAgrupadasPorNombreTareaYEmpleado: builder.query({
      query: ({ sucursal, nombre, fecha, tipo, fechaInicio, fechaFin }) => {
        const params = { fecha, nombre, tipo };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return {
          url: `/cantidadTareasAgrupadasPorNombreTareaYEmpleado/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    historialUltimasTareasFinalizadas: builder.query({
      query: ({ rut, sucursales }) => {
        const params = {};

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/historialUltimasTareasFinalizadas/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    historialUltimasTareasEspecialesIngresadas: builder.query({
      query: ({ rut, sucursales }) => {
        const params = {};

        if (sucursales && sucursales.length > 0) {
          params.sucursales = JSON.stringify(sucursales);
        }

        return {
          url: `/historialUltimasTareasEspecialesIngresadas/${rut}`,
          method: "GET",
          params,
        };
      },
    }),
    obtenerHistoricoTareasEmpleado: builder.query({
      query: (rut) => `/historicoTareasEmpleado/${rut}`,
    }),
    agregarTareaEspecial: builder.mutation({
      query(body) {
        return {
          url: `/especial`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Tarea"],
    }),
    agregarTareaEspecialMasiva: builder.mutation({
      query(body) {
        return {
          url: `/especialMasivo`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Tarea"],
    }),
    obtenerComisionesTarea: builder.query({
      query: (id) => {
        return {
          url: `/comisiones/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Comisiones"],
    }),
    editarComisionesTarea: builder.mutation({
      query({ idTarea, ...body }) {
        return {
          url: `/comisiones/${idTarea}`,
          method: "PUT",
          body,
        };
      },
    }),
    obtenerTareasEmpleadoPorSucursalYEstadoTarea: builder.query({
      query: ({ sucursal, estado, rut, fecha, fechaInicio, fechaFin }) => {
        const params = { fecha, estado, rut };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/tareasEmpleadoPorSucursalYEstadoTarea/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    obtenerTareasTotalesEmpleadosSucursal: builder.query({
      query: ({ sucursal, fecha, fechaInicio, fechaFin }) => {
        const params = { fecha };
        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return {
          url: `/tareasTotalesEmpleadosSucursal/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getTareasAll: builder.query({
      query: ({
        id,
        refEmpleado = null,
        rolObtenido = null,
        // Nuevos parámetros de paginación y filtros
        page = 0,
        limit = 10,
        orderBy = "fechaInicio",
        order = "asc",
        busqueda = "",
        estados = "",
        tipoTarea = "",
        fechaInicioDesde = null,
        fechaInicioHasta = null,
        fechaTerminoDesde = null,
        fechaTerminoHasta = null,
        cliente = null,
        empleado = null,
        incluirAdicionales,
        sucursales = null,
        soloEncargado = false,
      }) => {
        const params = {
          refEmpleado,
          rolObtenido,
          page,
          limit,
          orderBy,
          order,
        };

        if (busqueda) params.busqueda = busqueda;
        if (estados) params.estados = estados;
        if (tipoTarea) params.tipoTarea = tipoTarea;
        if (fechaInicioDesde) params.fechaInicioDesde = fechaInicioDesde;
        if (fechaInicioHasta) params.fechaInicioHasta = fechaInicioHasta;
        if (fechaTerminoDesde) params.fechaTerminoDesde = fechaTerminoDesde;
        if (fechaTerminoHasta) params.fechaTerminoHasta = fechaTerminoHasta;
        if (cliente) params.cliente = cliente;
        if (empleado) params.empleado = empleado;
        if (incluirAdicionales !== undefined)
          params.incluirAdicionales = incluirAdicionales;
        if (sucursales && sucursales.length > 0)
          params.sucursales = JSON.stringify(sucursales);
        // El backend solo necesita saberlo cuando el switch está encendido:
        // su default es false, así que apagarlo equivale a no enviar el parámetro.
        if (soloEncargado) params.soloEncargado = soloEncargado;

        return {
          url: `/all/${id}`,
          method: "GET",
          params,
        };
      },
      providesTags: ["Tarea"],
    }),
    exportTareasAll: builder.query({
      query: ({
        id,
        refEmpleado = null,
        rolObtenido = null,
        busqueda = "",
        estados = "",
        tipoTarea = "",
        fechaInicioDesde = null,
        fechaInicioHasta = null,
        fechaTerminoDesde = null,
        fechaTerminoHasta = null,
        cliente = null,
        empleado = null,
        sucursales = null,
      }) => {
        const params = {
          refEmpleado,
          rolObtenido,
        };

        if (busqueda) params.busqueda = busqueda;
        if (estados) params.estados = estados;
        if (tipoTarea) params.tipoTarea = tipoTarea;
        if (fechaInicioDesde) params.fechaInicioDesde = fechaInicioDesde;
        if (fechaInicioHasta) params.fechaInicioHasta = fechaInicioHasta;
        if (fechaTerminoDesde) params.fechaTerminoDesde = fechaTerminoDesde;
        if (fechaTerminoHasta) params.fechaTerminoHasta = fechaTerminoHasta;
        if (cliente) params.cliente = cliente;
        if (empleado) params.empleado = empleado;
        if (sucursales && sucursales.length > 0)
          params.sucursales = JSON.stringify(sucursales);

        return {
          url: `/export/${id}`,
          method: "GET",
          params,
        };
      },
    }),
    // Obtener clientes distintos por sucursal (o múltiples sucursales)
    getClientesDistintosPorSucursal: builder.query({
      query: ({ sucursal, refEmpleado, rolObtenido, sucursales = null }) => ({
        url: `/clientes-distintos/${sucursal}`,
        method: "GET",
        params: {
          refEmpleado,
          rolObtenido,
          ...(sucursales && sucursales.length > 0
            ? { sucursales: JSON.stringify(sucursales) }
            : {}),
        },
      }),
    }),

    // Obtener empleados distintos por sucursal (o múltiples sucursales)
    getEmpleadosDistintosPorSucursal: builder.query({
      query: ({ sucursal, sucursales = null }) => ({
        url: `/empleados-distintos/${sucursal}`,
        method: "GET",
        params:
          sucursales && sucursales.length > 0
            ? { sucursales: JSON.stringify(sucursales) }
            : {},
      }),
    }),
    getTareasParaFacturar: builder.query({
      query({ sucursal, rolObtenido = null }) {
        return {
          url: `/tareasParaFacturar/${sucursal}`,
          method: "GET",
          params: {
            rolObtenido: rolObtenido,
          },
        };
      },
      providesTags: ["Tareas"],
    }),
    obtenerTareasClienteFacturacion: builder.query({
      query(refCliente) {
        return {
          url: `/tareasClienteFacturacion/${refCliente}`,
          method: "GET",
        };
      },
    }),
    getCambioEstado: builder.query({
      query(id) {
        return {
          url: `/cambiaEstado/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Tareas"],
    }),
    getCliente: builder.query({
      query(id) {
        return {
          url: `/cliente/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Tareas"],
    }),
    getSucursal: builder.query({
      query(id) {
        return {
          url: `/sucursal/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Tareas"],
    }),
    getEmpleadosSinSucursal: builder.query({
      query(id) {
        return {
          url: `/empleadoSinSucursal/${id}`,
          method: "GET",
        };
      },
      providesTags: ["Tareas"],
    }),
    getTipoPlan: builder.query({
      query(id) {
        return {
          url: `/tipoPlan/${id}`,
          method: "GET",
        };
      },
    }),
    getTipoTarea: builder.query({
      query({ id, tipoTarea }) {
        return {
          url: `/tipoTarea/${id}/${tipoTarea}`,
          method: "GET",
        };
      },
    }),
    getTareasPorEstado: builder.query({
      query: ({ rutEmpleado, tipo }) =>
        `/tareasPorEstado/${rutEmpleado}/${tipo}`,
    }),
    getCantidadTareasMensualesYTotales: builder.query({
      query: ({ sucursal, fecha, fechaInicio, fechaFin }) => {
        const params = { fecha };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/cantidadTareasMensualesYTotales/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getTareasAnualesYMensualesAgrupadas: builder.query({
      query: ({ sucursal, fecha, fechaInicio, fechaFin }) => {
        const params = { fecha };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }

        return {
          url: `/tareasAnualesYMensualesAgrupadas/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getTareasInformacion: builder.query({
      query: ({ sucursal, fecha, fechaInicio, fechaFin, tipoTarea }) => {
        const params = { fecha, tipoTarea };

        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return {
          url: `/tareasInformacion/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getCantidadTareasEmpleadosAgrupadas: builder.query({
      query: ({
        sucursal,
        fecha,
        fechaInicio,
        fechaFin,
        tipoTarea,
        estadoTarea,
        nombreTarea,
      }) => {
        const params = { tipoTarea, estadoTarea, nombreTarea, fecha };
        if (fechaInicio) {
          params.fechaInicio = fechaInicio;
        }

        if (fechaFin) {
          params.fechaFin = fechaFin;
        }
        return {
          url: `/cantidadTareasAgrupadasPorEmpleadoYTarea/${sucursal}`,
          method: "GET",
          params,
        };
      },
    }),
    getEmpleado: builder.query({
      query({ refEmpleado, sucursal }) {
        return {
          url: `/empleado/${refEmpleado}/${sucursal}`,
          method: "GET",
        };
      },
    }),
    getTablero: builder.query({
      query({
        refEmpleado,
        sucursal,
        page = 0,
        limit = 10,
        orderBy = "fechaInicio",
        order = "asc",
        busqueda = "",
        estados = "",
        tipoTarea = "",
        fechaInicioDesde = null,
        fechaInicioHasta = null,
        fechaTerminoDesde = null,
        fechaTerminoHasta = null,
        cliente = null,
        empleado = null,
      }) {
        const params = { page, limit, orderBy, order };

        if (busqueda) params.busqueda = busqueda;
        if (estados) params.estados = estados;
        if (tipoTarea) params.tipoTarea = tipoTarea;
        if (fechaInicioDesde) params.fechaInicioDesde = fechaInicioDesde;
        if (fechaInicioHasta) params.fechaInicioHasta = fechaInicioHasta;
        if (fechaTerminoDesde) params.fechaTerminoDesde = fechaTerminoDesde;
        if (fechaTerminoHasta) params.fechaTerminoHasta = fechaTerminoHasta;
        if (cliente) params.cliente = cliente;
        if (empleado) params.empleado = empleado;

        return {
          url: `/inicio/${refEmpleado}/${sucursal}`,
          method: "GET",
          params,
        };
      },
      providesTags: ["Tareas"],
    }),
    getArchivos: builder.query({
      query(idTarea) {
        return {
          url: `/archivos/${idTarea}`,
          method: "GET",
        };
      },
      providesTags: ["archivosTarea"],
    }),
    subirArchivoATarea: builder.mutation({
      query: (body) => ({
        url: `/archivos`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["archivosTarea"],
    }),
    borrarArchivoTarea: builder.mutation({
      query: ({ id }) => ({
        url: `/archivos/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["archivosTarea"],
    }),
    getComisiones: builder.query({
      query(idTarea) {
        return {
          url: `/comisiones/${idTarea}`,
          method: "GET",
        };
      },
    }),
    updateCambiaEstado: builder.mutation({
      query: ({ id, body }) => ({
        url: `/cambiaEstado/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Tarea", "Tareas"],
    }),
    addResponderCambioEstado: builder.mutation({
      query({ id, body }) {
        return {
          url: `/responderCambioEstado/${id}`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["Tareas"],
    }),
    addSolicitudCambioEstado: builder.mutation({
      query(body) {
        return {
          url: `/solicitudCambioEstado`,
          method: "POST",
          body,
        };
      },
    }),
    deleteTarea: builder.mutation({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["Tareas"],
    }),
    updateTarea: builder.mutation({
      query: (body) => ({
        url: `/`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Tarea"],
    }),
    updateTareaFacturada: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/cambioEstado/facturado/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Tarea"],
    }),
    getNotificacionesTareas: builder.query({
      query: (rut) => `/notificaciones/${rut}`,
      providesTags: ["NotificacionesTareas"],
    }),

    // Portafolio Tareas - Obtener portafolios de una tarea
    obtenerPortafoliosTarea: builder.query({
      query: ({ idTarea }) => `/portafolio-tarea/${idTarea}`,
      providesTags: (result, error, { idTarea }) => [
        { type: "PortafoliosTarea", id: idTarea },
        "PortafoliosTarea",
      ],
    }),

    // Portafolio Tareas - Agregar portafolio
    agregarPortafolioTarea: builder.mutation({
      query: (body) => ({
        url: `/portafolio-tarea`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: (result, error, { refTarea }) => [
        { type: "PortafoliosTarea", id: refTarea },
        "PortafoliosTarea",
      ],
    }),

    // Portafolio Tareas - Actualizar portafolio
    actualizarPortafolioTarea: builder.mutation({
      query: (body) => ({
        url: `/portafolio-tarea`,
        method: "PUT",
        body: body,
      }),
      invalidatesTags: (result, error, { refTarea }) => [
        { type: "PortafoliosTarea", id: refTarea },
        "PortafoliosTarea",
      ],
    }),

    // Portafolio Tareas - Agregar archivo
    agregarArchivoPortafolioTarea: builder.mutation({
      query: (body) => ({
        url: `/portafolio-tarea/archivos`,
        method: "POST",
        body: body,
      }),
      invalidatesTags: ["PortafoliosTarea"],
    }),

    // Portafolio Tareas - Eliminar archivo
    eliminarArchivoPortafolioTarea: builder.mutation({
      query: ({ id, refPortafolioTarea, empleadoIngresaPortafolio }) => ({
        url: `/portafolio-tarea/archivos/${id}/${refPortafolioTarea}/${empleadoIngresaPortafolio}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PortafoliosTarea"],
    }),

    // Portafolio Tareas - Eliminar portafolio
    eliminarPortafolioTarea: builder.mutation({
      query: (id) => ({
        url: `/portafolio-tarea/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["PortafoliosTarea"],
    }),
  }),
});

export const {
  useGetNotificacionesTareasQuery,
  useLazyGetNotificacionesTareasQuery,
  useGetArchivosQuery,
  useGetCambioEstadoQuery,
  useGetClienteQuery,
  useGetComisionesQuery,
  useGetEmpleadoQuery,
  useGetEmpleadosSinSucursalQuery,
  useGetSucursalQuery,
  useGetTableroQuery,
  useGetTareaQuery,
  useGetTipoPlanQuery,
  useGetTipoTareaQuery,
  useGetTareasPorEstadoQuery,
  useGetTareasParaFacturarQuery,
  useObtenerTareasTotalesEmpleadosSucursalQuery,
  useObtenerHistoricoTareasEmpleadoQuery,
  useObtenerTareasClienteFacturacionQuery,
  useObtenerComisionesTareaQuery,
  useGetCantidadTareasMensualesYTotalesQuery,
  useGetTareasAnualesYMensualesAgrupadasQuery,
  useGetTareasInformacionQuery,
  useGetCantidadTareasEmpleadosAgrupadasQuery,
  useObtenerTareasEmpleadoPorSucursalYEstadoTareaQuery,
  useTareasPendientesMasAntiguasQuery,
  useHistorialUltimasTareasFinalizadasQuery,
  useHistorialUltimasTareasEspecialesIngresadasQuery,
  useGetTareasTotalesPorSucursalTipoTareaYFechaQuery,
  useGetCantidadTareasAgrupadasPorNombreTareaQuery,
  useGetTareasEmpleadosPorNombreTareaQuery,
  useGetCantidadTareasAgrupadasPorNombreTareaYEmpleadoQuery,
  useAgregarTareaEspecialMutation,
  useAgregarTareaEspecialMasivaMutation,
  useEditarComisionesTareaMutation,
  useAgregarTareaInternaMutation,
  useLazyObtenerTareasEmpleadoPorSucursalYEstadoTareaQuery,
  useLazyObtenerTareasTotalesEmpleadosSucursalQuery,
  useLazyGetCantidadTareasAgrupadasPorNombreTareaQuery,
  useLazyGetTareasEmpleadosPorNombreTareaQuery,
  useLazyGetCantidadTareasAgrupadasPorNombreTareaYEmpleadoQuery,
  useLazyGetCantidadTareasEmpleadosAgrupadasQuery,
  useLazyGetTareasTotalesPorSucursalTipoTareaYFechaQuery,
  useLazyGetTareasInformacionQuery,
  useLazyGetCantidadTareasMensualesYTotalesQuery,
  useLazyGetTareasAnualesYMensualesAgrupadasQuery,
  useLazyObtenerHistoricoTareasEmpleadoQuery,
  useLazyHistorialUltimasTareasEspecialesIngresadasQuery,
  useLazyObtenerTareasClienteFacturacionQuery,
  useLazyObtenerComisionesTareaQuery,
  useLazyTareasPendientesMasAntiguasQuery,
  useLazyHistorialUltimasTareasFinalizadasQuery,
  useLazyGetTareasParaFacturarQuery,
  useLazyGetTareasPorEstadoQuery,
  useLazyGetArchivosQuery,
  useLazyGetCambioEstadoQuery,
  useLazyGetClienteQuery,
  useLazyGetComisionesQuery,
  useLazyGetEmpleadoQuery,
  useLazyGetEmpleadosSinSucursalQuery,
  useLazyGetSucursalQuery,
  useLazyGetTableroQuery,
  useLazyGetTareaQuery,
  useLazyGetTipoPlanQuery,
  useLazyGetTipoTareaQuery,
  useUpdateCambiaEstadoMutation,
  useSubirArchivoATareaMutation,
  useDeleteTareaMutation,
  useBorrarArchivoTareaMutation,
  useAddResponderCambioEstadoMutation,
  useAddSolicitudCambioEstadoMutation,
  useUpdateTareaMutation,
  useUpdateTareaFacturadaMutation,
  useGetTareasAllQuery,
  useLazyGetTareasAllQuery,
  useExportTareasAllQuery,
  useLazyExportTareasAllQuery,
  // Portafolio tareas
  useObtenerPortafoliosTareaQuery,
  useLazyObtenerPortafoliosTareaQuery,
  useAgregarPortafolioTareaMutation,
  useActualizarPortafolioTareaMutation,
  useAgregarArchivoPortafolioTareaMutation,
  useEliminarArchivoPortafolioTareaMutation,
  useEliminarPortafolioTareaMutation,
  // Clientes y empleados distintos
  useGetClientesDistintosPorSucursalQuery,
  useLazyGetClientesDistintosPorSucursalQuery,
  useGetEmpleadosDistintosPorSucursalQuery,
  useLazyGetEmpleadosDistintosPorSucursalQuery,
} = tareasApi;
